// Slice 40 — Vite entry. Mount React 18 strict-root + global tokens.

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./tokens.css";
import { App } from "./App";

const root = document.getElementById("root");
if (!root) throw new Error("Missing #root — Vite index.html must include it.");
createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
